"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'limits.custom-branding.disabled': 'Funkcja niestandardowego brandingu nie jest dostępna w Twoim obecnym planie.',
};
